import React, { useEffect, useCallback, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { WizardPage, WizardPageTemplate, wizardProps } from 'gw-portals-wizard-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { withRouter, useHistory } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { useValidation } from 'gw-portals-validation-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import FNOLLossLocation from '../../components/LossLocation/LossLocation';
import metadata from './WherePage.metadata.json5';
import styles from './WherePage.module.scss';
import messages from '../../FNOL.messages';
import Claim from '../../models/Claim';

function FNOLWherePage(props) {
    const {
        wizardData: claimVM,
        updateWizardData,
        history: {
            location: { state = {} }
        },
        authHeader
    } = props;
    const translator = useContext(TranslatorContext);
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const {
        onValidate,
        isComponentValid,
        initialValidation,
        registerInitialComponentValidation
    } = useValidation('FNOLWherePage');

    const overrideProps = {
        lossLocationComponent: {
            path: !_.isUndefined(claimVM) ? claimVM : null,
            updatePath: updateWizardData
        },
        wherePageLoader: {
            loaded: !isLoading,
            loadingMessage: translator(messages.createDraftClaim)
        }
    };
    const { FNOLService } = useDependencies('FNOLService');

    const onNext = useCallback(() => {
        //const miscellaneous = claimVM.lossCause.value.code === 'otherobjcoll';
        const policyNumber = _.get(claimVM, 'policy.policyNumber.value');
        const isClaimNumberAvailable = _.get(claimVM, 'claimNumber.value');
        // if (isClaimNumberAvailable) {
        //     if (miscellaneous) {
        //         return redirectContactAgent();
        //     }
        //     return incidentPageHandling();
        // }
        setIsLoading(true);
        //return FNOLService.getFNOLDetails(policyNumber, claimVM.value, authHeader)
        return FNOLService.getFNOLDetails_EXT(claimVM.value, authHeader)
            .then((response) => {
                claimVM.value = new Claim(response);
                // if (miscellaneous) {
                //     return redirectContactAgent();
                // }
                // return incidentPageHandling();                
                const claimNumber = _.get(claimVM.value, 'claimNumber');
                const { redirectPath } = state;
                return history.push({
                    pathname: `/confirmation/${claimNumber}`,
                    state: {
                        redirectPath: redirectPath
                    }
                });
            })
            .catch((err) => {
                // ModalNextProvider.showAlert({
                //     title: messages.paCreateDraftErrorTitle,
                //     message: messages.paCreateDraftErrorMessage,
                //     status: 'error',
                //     icon: 'mi-error-outline',
                //     confirmButtonText: commonMessages.ok
                // }).catch(_.noop);
                // return false;
                return history.push('/claims');
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [FNOLService, authHeader, claimVM]);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            losslocationcomponent: FNOLLossLocation
        },
        resolveCallbackMap: {
            onValidate: onValidate
        }
    };

    const validateClaimStatus = useCallback(() => {
        const { claimStatus } = state;
        return !_.isNil(claimStatus);
    }, [state]);

    useEffect(() => {
        registerInitialComponentValidation(validateClaimStatus);
    }, [validateClaimStatus, registerInitialComponentValidation]);

    return (
        <WizardPage
            //onNext={onNext}
            cancelLabel={translator(messages.fnolCancel)}
            skipWhen={initialValidation}
            template={WizardPageTemplate}
            disableNext={!isComponentValid}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                onValidationChange={onValidate}
            />
        </WizardPage>
    );
}
// FNOLWherePage.propTypes = wizardProps;
// export default withRouter(FNOLWherePage);


FNOLWherePage.propTypes = wizardProps;
FNOLWherePage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired
};
export default withRouter(withAuthenticationContext(FNOLWherePage));